import RefreshIcon from '@mui/icons-material/Refresh';
import { type QueryKey,useQueryClient } from '@tanstack/react-query';

import { useCallback } from 'react';

import { Button } from '@ekhodealer/ekho-common/rev';

interface RefreshButtonProps {
	/**
	 * The query keys to reset.
	 */
	queryKeys: QueryKey[];
	/**
	 * Accessible label for the button.
	 * @default 'Refresh'
	 */
	ariaLabel?: string;
}

/**
 * A reusable refresh button that resets queries matching the provided query keys.
 * Uses resetQueries to clear the cache and trigger a refetch.
 */
export function RefreshButton({ queryKeys, ariaLabel = 'Refresh' }: RefreshButtonProps) {
	const queryClient = useQueryClient();

	const handleRefresh = useCallback(() => {
		queryKeys.forEach((queryKey) => {
			queryClient.resetQueries({ queryKey });
		});
	}, [queryClient, queryKeys]);

	return (
		<Button variant='ghost' size='large' onPress={handleRefresh} aria-label={ariaLabel}>
			<RefreshIcon />
		</Button>
	);
}
